import request from '@/utils/http';

// 司机运费确认 分页查询
export const queryPage = data => {
    return request({
        url: `/api-antms/query/driverCost/queryPage`,
        method: 'post',
        data
    });
};
// 司机运费确认 总数查询
export const queryCount = data => {
    return request({
        url: `/api-antms/query/driverCost/queryPageCount`,
        method: 'post',
        data
    });
};

// 司机运费确认 查询阿波罗服务平台配置
export const queryApolloSiteCodeList = data => {
    return request({
        url: `/api-antms/query/driverCost/queryApolloSiteCodeList`,
        method: 'post',
        data
    });
};

// 司机确认凭证 查询接口
export const queryDriverAttachment = data => {
    return request({
        url: `/api-antms/transport/attachment/list`,
        method: 'get',
        params: data
    });
};

// 司机运费确认 异常申诉
export const abnormalAppeal = data => {
    return request({
        url: `/api-antms/billing/driverCost/abnormalAppeal`,
        method: 'post',
        data
    });
};

// 司机运费确认 流程提交
export const appealConfirm = data => {
    return request({
        url: `/api-antms/billing/driverCost/appealConfirm`,
        method: 'post',
        data
    });
};

// 司机运费确认 流程信息查询
export const queryAbnormalAppeal = data => {
    return request({
        url: `/api-antms/billing/driverCost/queryAbnormalAppeal`,
        method: 'get',
        params: data
    });
};

// 司机运费确认 发车单明细查询
export const queryAbnormalAppealDetail = data => {
    return request({
        url: `/api-antms/billing/driverCost/queryAbnormalAppealDetail`,
        method: 'post',
        data
    });
};

// 司机运费确认 上传付款凭证
export const approvalFileImport = data => {
    return request({
        url: `/api-antms/billing/driverCost/abnormalAppeal/import`,
        method: 'post',
        data,
        headers: {
            'Content-type': 'multipart/form-data'
        }
    });
};

// 提交mip审核
export const createProcess = params => {
    return request({
        url: `/api-iflow/approveProcess?tenantCode=annto&appCode=APP202103050019`,
        method: 'post',
        data: params
    }).then(res => res);
};

// 确认状态推送BMS查询接口
export const getPushBmsResult = data => {
    return request({
        url: `/api-antms/query/driverCost/getPushBmsResult`,
        method: 'get',
        params: data
    });
};

// 确认状态推送BMS重推接口
export const rePushBms = data => {
    return request({
        url: `/api-antms/billing/driverCost/rePushBms `,
        method: 'post',
        data
    });
};
